module.exports = __webpack_public_path__ + "static/img/1959_11_02_TimeMagazine_AlbumReview.489bd37.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cage/archive/1959_11_02_TimeMagazine_AlbumReview.jpg
// module id = H6RH
// module chunks = 0